export default "__VITE_ASSET__91fGpQmI__"